const state = {
  shopCart: {
    products: {},
    ids: [],
    cartIds: [],
    sellers: {},
    sellerIds: []
  },
  planList: {
    products: {},
    ids: [],
    cartIds: [],
    sellers: {},
    sellerIds: []
  },
  localeLanguage: {
    language: localStorage.getItem('language') || `${navigator.language.slice(0,2)}_`
  },
};
export default state;





